export default function CategoryCard(p) {
  let cardStyle = { width: 200, height: 111 };
  let imageBlockStyle = { height: 111 };
  let imageStyle = { margin: "auto", display: "block", width: "100%", objectFit: "cover", height: 111 };
  let titleSize = " text-sm ";
  let imageUrl = "/images/business.jpg";

  if (p.text === "Business") imageUrl = "/images/business_200px.jpg";
  if (p.text === "Health") imageUrl = "/images/health_200px.jpg";
  if (p.text === "Spiritual") imageUrl = "/images/spiritual_200px.jpg";
  if (p.text === "Personal Growth") imageUrl = "/images/personal-growth_200px.jpg";
  if (p.text === "School") imageUrl = "/images/school_200px.jpg";
  if (p.text === "Environment") imageUrl = "/images/environment_200px.jpg";
  if (p.text === "Arts") imageUrl = "/images/arts_200px.jpg";
  if (p.text === "Science") imageUrl = "/images/science_200px.jpg";
  if (p.text === "Top") imageUrl = "/images/top_200px.jpg";
  if (p.text === "All Videos") imageUrl = "/images/all_200px.jpg";
  if (p.text === "Browse Categories") imageUrl = "/images/categories_200px.jpg";
  if (p.text === "..more") imageUrl = "/images/...more_200px.jpg";

  return (
    <a
      style={{ height: 111 }}
      href={p.url}
      className="shadow-md rounded-lg overflow-hidden  flex flex-col justify-between bg-white  mb-2"
    >
      <div key={p.id} style={cardStyle}>
        <div className="flex flex-col justify-end border ">
          <div
            style={{
              WebkitFilter: "grayscale(50%)",
              MozFilter: "grayscale(50%)",
              OFilter: "grayscale(50%)",
              msFilter: "grayscale(50%)",
              filter: "grayscale(50%)",
            }}
          >
            <img src={imageUrl} height="111px" width="200px" key={p.text} />
          </div>
        </div>
        <div
          style={{ width: 200 }}
          className={"-mt-20 z-50  text-2xl absolute font-extrabold break-words text-white text-center leading-none "}
        >
          {p.text}
        </div>
      </div>
    </a>
  );
}
